import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFProductWinAdd from '@/components/UI/svg/mm100/Icon/EFProductWinAdd';
import EFRightArrow from '@/components/UI/svg/mm100/Icon/EFRightArrow';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

export default function Comp({ callBack, type = 'rv' }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    const list_rv = [
        {
            src: ['listC1.webp', 'listC1.png'],
            title: t('presale.product.listC_list_title1'),
        },
        {
            src: ['listC2.webp', 'listC2.png'],
            title: t('presale.product.listC_list_title2'),
        },
        {
            src: ['listC3.webp', 'listC3.png'],
            title: t('presale.product.listC_list_title3'),
        },
    ];

    const list_house = [
        {
            src: ['listC4.webp', 'listC4.png'],
            title: t('presale.product.listC_list_title4'),
        },
        {
            src: ['listC5.webp', 'listC5.png'],
            title: t('presale.product.listC_list_title3'),
        },
    ];

    const [list, setList] = useState(list_rv);
    useEffect(() => {
        setList(type === 'rv' ? list_rv : list_house);
    }, [type]);

    const openAllWin = () => callBack('modal-solar-panels');

    return (
        <div className={`${css.listC} listC`}>
            <div className="kit-ms1">{t('presale.product.listC_ms1')}</div>
            <div className="kit-ms2">{t('presale.product.listC_ms2')}</div>
            <div className="kit-ms3">{t('presale.product.listC_ms3')}</div>
            <div className="kit-ms4">{t('presale.product.listC_ms4')}</div>
            <div className="more-win-fun" onClick={openAllWin}>
                {t('presale.product.listC_more_win_fun')}
                <span className="more-win-fun-icon">
                    <EFProductWinAdd />
                </span>
            </div>
            <div className="list-box">
                {list?.map((item: any, index: number) => (
                    <div className="list-item" key={index}>
                        <div className="list-img">
                            <EFPic name={item.src} className="fullImgs" alt={item.title} />
                        </div>
                        <div className="list-ms">{item.title}</div>
                        <div className="list-link ef-blue-link">
                            <a href={undefined} onClick={openAllWin}>
                                {t('presale.product.listC_learn_more')}
                                <span className="ef-blue-link-more">
                                    <EFRightArrow />
                                </span>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
